import {ProdesegButton, ProdesegButtonEnumTypes, ProdesegButtonProps} from "./ProdesegButton/ProdesegButton";
import {ReactNode, useRef} from "react";
import axios from "axios";
import Alerts from "../util/Alerts";
import {useBoolean} from "../custom-hooks/useBoolean";
import JedaiTooltip from "../coms/JedaiTooltip";

interface PayloadSearch extends Record<string, unknown> {
    filtered?: [];
    sorted?: [];
}

interface ExportAccidentsProps extends Omit<ProdesegButtonProps, "children" | "type" | "onClick"> {
    url: string;
    type?: ProdesegButtonEnumTypes;
    fileName?: string;
    buttonText?: ReactNode;
    confirmationMessage?: string;
    payloadSearch: PayloadSearch;
    show?: boolean;
}

export const FileDownloadButton = ({
                                       url,
                                       fileName,
                                       type = ProdesegButtonEnumTypes.Primary,
                                       buttonText = "Descargar Excel",
                                       confirmationMessage = "Este proceso puede tomar su tiempo. ¿Desea continuar?",
                                       payloadSearch: {filtered = [], sorted = [], ...values},
                                       isDisabled,
                                       title,
                                       show = true,
                                       ...buttonProps
                                   }: ExportAccidentsProps) => {
    const alert = useRef<{ show_error: (e: string) => void }>(null);

    const {value: isGenerating, setTrue: setIsGeneratingTrue, setFalse: setIsGeneratingFalse} = useBoolean(false);

    const doExport = () => {
        if (!window.confirm(confirmationMessage)) return;
        setIsGeneratingTrue();
        axios
            .post(url, {...values, filtered, sorted}, {responseType: "blob"})
            .then(response => {
                const url = URL.createObjectURL(response.data);
                const contentDisposition = response.headers["content-disposition"];
                let currentFileName = fileName;
                if (!fileName && contentDisposition?.includes("filename=")) {
                    const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                    if (match) currentFileName = match[1].replace(/['"]/g, "");
                }
                const link = document.createElement("a");
                link.href = url;
                link.download = currentFileName ?? "file";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            })
            .catch(async error => {
                let errorMessage = await error?.response?.data?.text();
                errorMessage = JSON.parse(errorMessage);
                alert.current?.show_error(errorMessage?.message ?? "Hubo un error generando el archivo");
            })
            .finally(setIsGeneratingFalse);
    };

    if (!show) return null;

    return (
        <>
            <div className={"d-flex align-items-center"} style={{gap: "10px"}}>
                {title && (
                    <JedaiTooltip message={title}>
                        <i className={"fa fa-info-circle"}/>
                    </JedaiTooltip>
                )}
                <ProdesegButton
                    type={type}
                    isOutline
                    onClick={doExport}
                    isDisabled={isDisabled || isGenerating}
                    {...buttonProps}
                >
                    {buttonText}
                    {isGenerating && <i className={"ml-2 fa-solid fa-spinner fa-pulse"}/>}
                </ProdesegButton>
            </div>
            <Alerts ref={alert}/>
        </>
    );
};
